import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Lozinke se ne poklapaju");
    if (password.length < 6) return toast.error("Lozinka mora imati bar 6 karaktera");
    if (!token) return toast.error("Nedostaje token — otvori link iz email-a");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) { toast.error(formatApiError(err)); }
    setLoading(false);
  };

  if (done) {
    return (
      <div className="min-h-screen grid place-items-center p-6">
        <div className="w-full max-w-md surface-card p-8 text-center" data-testid="reset-done">
          <div className="w-12 h-12 rounded-full bg-forest/10 grid place-items-center mx-auto mb-4">
            <KeyRound className="w-6 h-6 text-forest" />
          </div>
          <h2 className="text-2xl font-heading font-semibold">Lozinka promenjena</h2>
          <p className="text-sm text-ink-muted mt-3">Prebacujemo te na prijavu...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <form onSubmit={submit} className="w-full max-w-md surface-card p-8" data-testid="reset-form">
        <div className="overline mb-2">Nova lozinka</div>
        <h2 className="text-3xl font-heading font-semibold tracking-tight">Postavi novu lozinku</h2>
        <p className="text-sm text-ink-muted mt-2">Unesi novu lozinku dva puta.</p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium">Nova lozinka (min. 6)</label>
            <input
              data-testid="reset-password"
              type="password"
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-1 px-3 py-2.5 bg-white border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-forest"
              required
            />
          </div>
          <div>
            <label className="text-sm font-medium">Potvrdi lozinku</label>
            <input
              data-testid="reset-confirm"
              type="password"
              minLength={6}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full mt-1 px-3 py-2.5 bg-white border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-forest"
              required
            />
          </div>
          <button data-testid="reset-submit" disabled={loading} className="btn-primary w-full justify-center">
            {loading ? "Menjam..." : "Postavi lozinku"}
          </button>
        </div>

        <div className="text-sm text-ink-muted mt-6">
          <Link to="/login" className="text-forest font-medium hover:underline">← Nazad na prijavu</Link>
        </div>
      </form>
    </div>
  );
}
